(function(){
  function boot(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var selectors=[
      'main .shopify-section:not(:first-child)',
      '.ry-redesign-root main > section:not(:first-child)',
      '.ry-system-page .ry-start-step',
      '.ry-system-page .ry-sys-card',
      '.ry-system-page .ry-report-card',
      '.ry-system-page .ry-rocket-row',
      '.ry-system-page .ry-journey-step'
    ];
    var nodes=[];
    selectors.forEach(function(sel){document.querySelectorAll(sel).forEach(function(el){if(nodes.indexOf(el)<0)nodes.push(el);});});
    if(!nodes.length)return;
    document.documentElement.classList.add('ry-motion-ready');
    nodes.forEach(function(el,i){
      el.classList.add('ry-motion-reveal');
      if(el.classList.contains('ry-report-card')) el.classList.add(i%2?'ry-motion-reveal-right':'ry-motion-reveal-left');
      el.style.setProperty('--ry-motion-delay',((i%3)*65)+'ms');
    });
    if(reduce||!('IntersectionObserver' in window)){nodes.forEach(function(el){el.classList.add('ry-motion-visible','is-visible');});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('ry-motion-visible','is-visible');io.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    nodes.forEach(function(el){io.observe(el);});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
